import { createContext, useContext } from 'react';
import { UseFormRegisterReturn, UseFormReturn } from 'react-hook-form';
import { FormCounterProps, FormElementProps, FormTextHelper } from '../types';

export interface FormContextType extends Omit<FormElementProps, 'children'>, FormTextHelper, FormCounterProps {
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (value: React.FocusEvent<HTMLInputElement>) => void;
  ref?: UseFormRegisterReturn['ref'];
  control?: UseFormReturn['control'];
  /**
   * Display error state
   */
  isError?: boolean;
  /**
   * Display success state
   */
  isSuccess?: boolean;
}

export const FormContext = createContext<FormContextType>({} as FormContextType);

export const useFormContext = () => {
  const context = useContext(FormContext);
  return context;
};
